import { FormField, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { DecommissioningFieldsView } from '../../../../types/form-types'

interface WellConstructionDecommissioningViewInterface {
  fields: Partial<DecommissioningFieldsView>
  isLoading: boolean
}

export default function WellConstructionDecommissioningView({
  fields,
  isLoading,
}: WellConstructionDecommissioningViewInterface) {
  return (
    <>
      <FormField isSkeleton={isLoading} label='Decommissioned date' labelId='decommissionedDateLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='decommissionedDateLabel'
          value={`${fields.decommissionedDate ?? ''}`}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Decommissioned by' labelId='decommissionedByCompanyLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='decommissionedByLabel'
          value={`${fields.decommissionedByCompany ?? ''}`}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.decommissioningDetails}
        isSkeleton={isLoading}
        label='Decommissioning details'
        labelId='decommissioningDetailsLabel'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='decommissioningDetailsLabel'
          value={`${fields.decommissioningDetails ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Decommissioning method' labelId='decommissioningMethodLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='decommissioningMethodLabel'
          value={`${fields.decommissioningMethod ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Decommissioning verified' labelId='recordVerifiedByDateLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='recordVerifiedByDateLabel'
          value={`${fields.recordVerifiedByDate ?? ''}`}
        />
      </FormField>

      <FormField
        isSkeleton={isLoading}
        label='Is compliant with NZ standards'
        labelId='isCompliantWithNzStandardsLabel'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='isCompliantWithNZStandardsLabel'
          value={fields.isCompliantWithNzStandards}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Additional comments' labelId='additionalCommentsLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='additionalCommentsLabel'
          value={fields.decommissioningMethodAdditionalComments}
        />
      </FormField>
    </>
  )
}
